import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ContentBlock from '../../../../../../components/Layout/ContentBlock';
import { MainColumns } from '../../../../../../components/TableGrid';
import { Branch } from '../../../../../../generated/model/models';
import DetailsDataTableWithHistory from '../../shared/DetailsDataTableWithHistory';

export interface Props {
  data?: Branch;
}

const defaultColumns: MainColumns[] = [
  { field: 'sanctionsList', minWidth: 150, flex: 1 },
  { field: 'program', minWidth: 200, flex: 1 },
  { field: 'relatedNames', minWidth: 300, flex: 1 },
  { field: 'comments', minWidth: 200, flex: 1 },
  { field: 'dataDate', minWidth: 150, flex: 1 },
  { field: 'status', minWidth: 150, flex: 1 },
];

const companyColumns: MainColumns[] = [{ field: 'entityName', minWidth: 200, flex: 1 }];

const personColumns: MainColumns[] = [{ field: 'personName', minWidth: 200, flex: 1 }];

const SanctionsList: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.generalInfoBox}>
      <ContentBlock title={t(`companies:companyIssues:sanctions:global`)}>
        <Box className={classes.box}>
          <DetailsDataTableWithHistory
            title={'companies'}
            translationsScope={'companies:companyIssues.sanctions'}
            data={data}
            columns={[...companyColumns, ...defaultColumns]}
            defaultHistoryToggleValue={true}
          />
          <DetailsDataTableWithHistory
            title={'persons'}
            translationsScope={'companies:companyIssues.sanctions'}
            data={data}
            columns={[...personColumns, ...defaultColumns]}
            defaultHistoryToggleValue={true}
          />
        </Box>
      </ContentBlock>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  generalInfoBox: {
    width: '100%',
    marginRight: theme.spacing(8),
    display: 'flex',
  },
  cellContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  itemsBlock: {
    display: 'flex',
    flexDirection: 'row',
  },
  item: {
    padding: theme.spacing(5),
    flexGrow: 1,
    flexBasis: 0,
  },
  box: {
    marginTop: '15px',
    marginLeft: '15px',
  },
}));

export default SanctionsList;
